/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from "react";
import { Control, UseFormWatch, useFieldArray } from "react-hook-form";
import { useParams } from "react-router-dom";

import { useGenerateProductVariantSKUAndShortId } from "../apis";
import { GenerateProductVariantSKUAndShortIdResponse } from "../apis/useGenerateProductVariantSKUAndShortId";
import { ProductFormValues } from "../components";
import { createInitialProductFormVariantItem } from "../helpers";

const useProductVariantsFormFields = (
  watch: UseFormWatch<ProductFormValues>,
  control: Control<ProductFormValues>
) => {
  const { subChildCategoryId } = useParams();

  const watchSizes = watch("sizes");
  const watchColors = watch("colors");

  const addNewVariant = (
    skuAndShortId: GenerateProductVariantSKUAndShortIdResponse
  ) => {
    const newColorAttributeValueId = watchColors[watchColors.length - 1].value;

    const sizeAttributeValueIds = watchSizes.map(
      (size) => size.sizeAttributeValueId
    );

    prependVariant(
      createInitialProductFormVariantItem(
        newColorAttributeValueId,
        sizeAttributeValueIds,
        skuAndShortId
      )
    );
  };

  const { mutate: mutateGenerateSKU, isLoading: isLoadingSKU } =
    useGenerateProductVariantSKUAndShortId({
      onSuccess: addNewVariant
    });

  const {
    fields: variantFields,
    prepend: prependVariant,
    remove: removeVariant
  } = useFieldArray({
    control,
    name: "variants"
  });

  const updateVariantsList = () => {
    if (watchColors.length === variantFields.length) {
      return;
    }

    if (watchColors.length > variantFields.length) {
      mutateGenerateSKU({ categoryId: String(subChildCategoryId) });
    } else {
      const removingIndex = variantFields.findIndex((variant) =>
        watchColors.every(
          ({ value }) => value !== variant.colorAttributeValueId
        )
      );

      removeVariant(removingIndex);
    }
  };

  useEffect(updateVariantsList, [watchColors]);

  return { variantFields, isLoadingSKU };
};

export default useProductVariantsFormFields;
